// client/src/components/transportadores/TransportadorRow.js
import React from 'react';
import { MoreVertical, UserCircle, Building as BuildingIcon } from 'lucide-react';

const formatDocumento = (doc, tipoPessoa) => {
    if (!doc) return 'N/D';
    const raw = String(doc).replace(/\D/g, '');
    if (tipoPessoa === 'Física') {
        return raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return raw.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

const formatTelefone = (telefone) => {
    if (!telefone) return '-';
    return String(telefone).replace(/\D/g, '').replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
};

const TransportadorRow = ({ transportador, displayId, onOpenActions, loading }) => {
    if (!transportador) {
        return (
            <tr>
                <td colSpan="7" className="py-3 px-4 text-sm text-center text-gray-500">Dados do transportador indisponíveis.</td>
            </tr>
        );
    }

    const { tipoPessoa, nomeCompleto, cpf, razaoSocial, nomeFantasia, cnpj, telefone, motoristas, veiculos } = transportador;

    const nomePrincipal = tipoPessoa === 'Física' ? nomeCompleto : (nomeFantasia || razaoSocial);
    const documento = tipoPessoa === 'Física' ? formatDocumento(cpf, tipoPessoa) : formatDocumento(cnpj, tipoPessoa);

    return (
        <tr className="table-row-hover">
            <td className="td-id">{displayId}</td>
            <td className="td-name" title={tipoPessoa === 'Jurídica' && nomeFantasia && nomeFantasia !== razaoSocial ? `Razão: ${razaoSocial}` : undefined}>
                {tipoPessoa === 'Física' ? <UserCircle size={15} className="inline mr-1.5 text-gray-500" /> : <BuildingIcon size={15} className="inline mr-1.5 text-gray-500" />}
                {nomePrincipal || 'N/D'}
                {tipoPessoa === 'Jurídica' && nomeFantasia && nomeFantasia !== razaoSocial && (
                    <span className="text-xs text-gray-500 block sm:inline sm:ml-1">({razaoSocial})</span>
                )}
            </td>
            <td className="table-cell">{documento}</td>
            <td className="table-cell">{formatTelefone(telefone)}</td>
            <td className="table-cell whitespace-nowrap">{motoristas ? motoristas.length : 0}</td>
            <td className="table-cell whitespace-nowrap">{veiculos ? veiculos.length : 0}</td>
            <td className="text-right">
                <button onClick={() => onOpenActions(transportador)} title="Ações" className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={loading}>
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

export default TransportadorRow;
